import React from 'react';
import {
    withStyles,
    ListItem,
    Button,
    Grid,
    Typography,
    ButtonBase,
    Divider,
    Snackbar,
    Tabs,
    Tab,
} from '@material-ui/core';
import Cancel from '@material-ui/icons/Cancel';
import Apis from '../../network/Apis';

import {
    withRouter,
} from "react-router-dom"

import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';
import MArrowBack from '../view/MArrowBack';
import TabIndicator from '../view/TabIndicator';


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BG_IMG = require("../../images/login/img_login_bg.jpg");


class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this._onItemClick = this._onItemClick.bind(this);
        this._onCancel = this._onCancel.bind(this);
        this._getPhoneCode = this._getPhoneCode.bind(this);
        this.validatePhone = this.validatePhone.bind(this);
        this.state = {
            avatar: AppData.me.Pic,
            phone: "",
            code: '',
            codeTip: '获取验证码',
            snackopened: false,
            message: '',
            tabIndex: 0,
            account: '',
            password: '',
        }
    }

    componentDidMount() {
        window.prevLoadingJs();
        AppUtils.YMPush('MAIN', 'LoginPage');
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _onCancel() {
        this.setState({ phone: '' });
    }

    _onUserLogin = async () => {
        const { tabIndex } = this.state;
        let phone = '';
        if (tabIndex == 0) {
            if (!this.validatePhone(this.state.phone)) {
                this.setState({ message: '请正确填写手机号码' + this.state.phone, snackopened: true });
                return;
            }

            if (this.state.code == '' || this.state.code.length < 4) {
                this.setState({ message: '请正确输入验证码' + this.state.phone, snackopened: true });
                return;
            }
            phone = this.state.phone;
            this.state.password = '';
        } else {
            const { account, password } = this.state;
            if (!this.validatePhone(account)) {
                this.setState({ message: '请正确填写手机号码' + account, snackopened: true });
                return;
            }
            if (password == '' || password.length < 6) {
                this.setState({ message: '请正确输入密码' + password, snackopened: true });
                return;
            }
            phone = account;
            this.state.code = '';
        }

        let result = await Apis.encryptionCustomerLogin(phone, this.state.code, this.state.password);
        console.log('_onUserLogin', result);
        if (result.code == 200) {
            AppData.me.token = result.data.token;
            AppData.me.customer_id = result.data.customer_id;
            AppData.me.PhoneNum = phone;
            localStorage.setItem("phone_num", AppData.me.PhoneNum);
            localStorage.setItem("user_token", AppData.me.token);
            localStorage.setItem("user_customer_id", AppData.me.customer_id);
            AppData.loginIn();
            AppUtils.YMPush('MAIN', '登录成功');
            this.props.history.push('/');

        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    validatePhone(phone) {
        console.log('validatePhone', phone);
        var re = /^1[3-9]\d{9}$/;
        return re.test(phone);
    }

    _getPhoneCode = async () => {
        if (!this.validatePhone(this.state.phone)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }

        let result = await Apis.encryptionSendCode(this.state.phone);
        console.log('encryptionSendCode', result);
        if (result.code == 200) {
            this._verifyCodeTimeAction();
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    _verifyCodeTimeAction() {
        const codeTime = 60;
        this.setState({
            codeTip: codeTime,
        });
        const now = Date.now()
        const overTimeStamp = now + codeTime * 1000 + 100/*过期时间戳（毫秒） +100 毫秒容错*/
        this.interval = setInterval(() => {
            /* 切换到后台不受影响*/
            const nowStamp = Date.now()
            if (nowStamp >= overTimeStamp) {
                /* 倒计时结束*/
                this.interval && clearInterval(this.interval);
                this.setState({
                    codeTip: '获取验证码',
                });
            } else {
                const leftTime = parseInt((overTimeStamp - nowStamp) / 1000, 10)
                this.setState({
                    codeTip: leftTime,

                });
            }
        }, 1000);
    }

    _onItemClick(idx) {
        switch (idx) {
            case 0:
                //登录
                this._onUserLogin();
                break;
            default:
                break;
        }
    }

    onTabChange = (index) => {
        console.log('onTabChange', index);
        this.setState({ tabIndex: index });
    }

    _onFindPwd = () => {
        this.props.history.push('/findpwd');
    }

    renderPhoneLogin = () => {
        const { classes } = this.props;
        const { phone, code, codeTip } = this.state;
        return (
            <Grid>
                <ListItem disableRipple button style={{ backgroundColor: 'transparent', height: 45 }}>
                    <input
                        onChange={event => this.setState({ phone: event.target.value })}
                        value={phone}
                        type='tel'
                        className={classes.textfield}
                        placeholder='请输入手机号码'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <Grid container justify='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '89%', justifyContent: 'center' }} />
                </Grid>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <input
                        onChange={event => this.setState({ code: event.target.value })}
                        value={code}
                        type='number'
                        className={classes.textfield}
                        placeholder='请输入验证码'
                    />
                    <Typography className={classes.checkfont} style={{ width: 80, textAlign: 'center' }} onClick={() => this._getPhoneCode()}> {codeTip} </Typography>
                </ListItem>
                <Grid container justify='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '89%', justifyContent: 'center' }} />
                </Grid>
            </Grid>
        );
    }

    renderAccountLogin = () => {
        const { classes } = this.props;
        const { account, password } = this.state;
        return (
            <Grid>
                <ListItem disableRipple button style={{ backgroundColor: 'transparent', height: 45 }}>
                    <input
                        onChange={event => this.setState({ account: event.target.value })}
                        value={account}
                        type='tel'
                        className={classes.textfield}
                        maxLength={15}
                        placeholder='请输入手机号码'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <Grid container justify='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '89%', justifyContent: 'center' }} />
                </Grid>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <input
                        onChange={event => this.setState({ password: event.target.value })}
                        value={password}
                        type='password'
                        className={classes.textfield}
                        placeholder='请输入密码'
                    />
                </ListItem>
                <Grid container justify='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '89%', justifyContent: 'center' }} />
                </Grid>
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { snackopened, message, tabIndex } = this.state;
        return (
            <React.Fragment>
                <div className={classes.root}>
                    <MArrowBack sytle={{ color: '#FFF' }} />
                    <Grid style={{ height: '20vh' }}></Grid>
                    <Grid container direction='row' style={{ width: '100vw' }}>
                        <Typography className={classes.tittle}> 欢迎来到播球帝 </Typography>
                    </Grid>
                    <Grid container direction='column' className={classes.content} >
                        <Grid container direction='column' sytle={{ width: '100%' }}>
                            <Tabs
                                value={tabIndex}
                                onChange={(e, val) => this.onTabChange(val)}
                                variant="fullWidth" aria-label="simple tabs example"
                                TabIndicatorProps={{ children: <TabIndicator width={60} />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                                style={{ minHeight: 32 }}
                            >
                                <Tab wrapped={false} label='验证码登录' style={{ color: tabIndex == 0 ? '#0D0D0D' : '#878787', fontSize: 15, height: '100%', padding: 0, fontWeight: 'bold' }}></Tab>
                                <Tab wrapped={false} label='密码登录' style={{ color: tabIndex == 1 ? '#0D0D0D' : '#878787', fontSize: 15, height: '100%', padding: 0, fontWeight: 'bold' }}></Tab>
                            </Tabs>
                            <Grid style={{ width: '100%', backgroundColor: '#E2E2E2', height: 1 }}></Grid>
                        </Grid>
                        <Grid style={{ height: 16 }}></Grid>
                        <Grid>
                            {
                                tabIndex == 0 && this.renderPhoneLogin()
                            }
                            {
                                tabIndex == 1 && this.renderAccountLogin()
                            }
                        </Grid>
                        <Grid container justify='center' direction='column' alignItems='center' sytle={{ width: '100%' }}>
                            <ButtonBase className={classes.logoutBtn} onClick={() => this._onItemClick(0)}>登 录</ButtonBase>
                            {
                                tabIndex == 0 && <Typography className={classes.checkfont}> 未注册的手机号将被直接注册 </Typography>
                            }
                            {
                                tabIndex == 1 && <Typography className={classes.checkfont} onClick={() => this._onFindPwd()} > 找回密码 </Typography>
                            }
                        </Grid>

                    </Grid>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this.setState({ snackopened: false })}
                        message={message}
                        autoHideDuration={3000}>
                    </Snackbar>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100vw',
        height: '100vh',
        display: "flex",
        flexDirection: "column",
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        backgroundSize: 'cover',
        backgroundImage: `url(${BG_IMG})`,
        animation: 'ani 10s linear infinite both alternate'
    },
    logoutBtn: {
        background: 'linear-gradient(135deg, #15A5B6, #3AF23A)',
        borderRadius: 22.5,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    tittle: {
        fontSize: 28,
        padding: theme.spacing(0, 0, 4, 4),
        color: '#FFF'
    },
    checkfont: {
        fontSize: 10,
        color: '#0d0d0d',
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 15,
        height: 30,
        marginLeft: 10,
        borderRadius: 10,
        width: '90%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(1, 1, 1, 1),
    },
    content: {
        backgroundColor: '#FFF',
        minHeight: '40vh',
        width: 'calc(100vw - 16px)',
        borderRadius: 16,
    }

}))(LoginPage));